import type { EditableCallback } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../../../graphql';
import type {
  InvestorCoverageGridContext,
  InvestorCoverageRow,
} from '../InvestorCoverageGrid.model';

export const isInvestorCoverageColumnEditable: EditableCallback<
  InvestorCoverageRow,
  unknown,
  InvestorCoverageGridContext
> = ({ context, data }) => context.isEditable && data?.firmStatus === RolodexRecordStatus.Effective;
